import { useMemo } from 'react'

import { FixedBanner } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

import { useAceBlockchain } from '../../hooks'

import type { BlockchainAbbreviation } from '@shared/graphql'

export interface AceAlertProps {
  /**
   * Blockchain abbreviation.
   */
  blockchain?: BlockchainAbbreviation
  /**
   * Custom className.
   */
  className?: string
}

export const AceAlert: React.FC<AceAlertProps> = ({
  blockchain,
  className,
}) => {
  const { t } = useTranslation('ace')

  const { aceBlockchain } = useAceBlockchain(blockchain)

  const displayAlert = useMemo(
    () => aceBlockchain !== undefined,
    [aceBlockchain],
  )

  if (!displayAlert) {
    return null
  }

  return (
    <FixedBanner
      className={className}
      data-testid="ace-legal-alert"
      status="info"
      multiline
    >
      <FixedBanner.Description>
        {t('alert.blockchain.description', {
          blockchain: aceBlockchain?.name,
        })}
      </FixedBanner.Description>
    </FixedBanner>
  )
}
